import { render } from "./coupon-dialog.vue?vue&type=template&id=8e54a66e&scoped=true"
import script from "./coupon-dialog.vue?vue&type=script&lang=js"
export * from "./coupon-dialog.vue?vue&type=script&lang=js"

import "./coupon-dialog.vue?vue&type=style&index=0&id=8e54a66e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e54a66e"]])

export default __exports__